import axios from '@/plugins/axios'
import { MessageBox, Message } from 'element-ui'
import { pick as _pick } from 'lodash'

export default {
  namespaced: true,

  state: {
    loading: false,
    tracks: [],
    dialog_form: false,
    dialog_deposit: false,
    active_label: null,
    active_campaign: null,
    track_list: [],
    editDialog: false,
    track: {
      id: null,
      campaign_packages_id: 1,
      name: null,
      vc_rate: 10,
      date_range: '',
      active: null,
      bronze_tier_timeout: null,
      campaign_track_end: '',
      days: 0,
      silver_tier: false,
      balance:0,
      youtube_categories: [],
      subscriberReach: null,
      youtubeCategoryDays: null,
      balanceAction: null,
      bonusType: null,
      bands: []
    },
    campaign_packages: [],
    youtubeCategories: []
  },

  mutations: {
    setTrack(state, payload) {
      state.track = payload
    },
    setTracks(state, payload) {
      state.tracks = payload
    },
    setTrackForm(state, status) {
      state.dialog_form = status
      state.track.id = null
      state.track.bands = 0
    },
    setTrackDeposit(state, status) {
      state.dialog_deposit = status
    },
    setTrackList(state, payload) {
      state.track_list = payload
    },
    setActiveLabel(state, payload) {
      state.active_label = payload
    },
    setActiveCampaign(state, payload) {
      state.active_campaign = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setEditDialog(state, status) {
      state.editDialog = status
    },
    setActive(state, status) {
      state.track.active = status
    },
    setCampaignPackages(state, payload) {
      state.campaign_packages = payload
    },
    setYoutubeCategories(state, categories) {
      state.youtubeCategories = categories
    }
  },

  actions: {
    createTrack({ state, dispatch, commit }) {
      let balance = state.track.balance * 10
      axios.api
        .post(
          `vc/label/campaign/create`,
          {
            name: state.track.name,
            campaign_packages_id: state.track.campaign_packages_id,
            label_id: state.active_label,
            sv_track_id: state.track.id,
            vc_start: state.track.date_range[0],
            vc_end: state.track.date_range[1],
            days: state.track.days,
            balance: balance,
            youtube_categories: state.track.youtube_categories,
            subscriberReach: state.track.subscriberReach,
            youtubeCategoryDays: state.track.youtubeCategoryDays,
            bonusType: state.track.bonusType,
            bands: state.track.bands
          }
        )
        .then(() => {
          commit('setTrackForm', false)
          this.dispatch('vcLabel/readLabels')
        })
    },

    editTrack({ state, commit, dispatch }) {
      let alertMsg = ''
      const changed_balance = parseFloat(state.track.balance.toFixed(2)) !== parseFloat(state.active_campaign.balance.toFixed(2))

      if (changed_balance) {
        if (state.track.balanceAction === 'add') {
          alertMsg = `You will deposit $${state.track.balance} to ${state.active_campaign.track.title} track. Continue?`
        } else if (state.track.balanceAction === 'subtract') {
          alertMsg = `You will return $${state.track.balance} deposit to ${state.active_campaign.name} label. Continue?`
        }
        else return Message.info('You need to select add or subtract, if you want to change current balance')
      } else alertMsg = `Confirm edit campaign. Continue?`

      const track = _pick(state.track, [
        'id', 'label_id', 'active', 'bronze_tier_timeout', 'campaign_track_end', 'vc_rate',
        'balance', 'campaign_packages_id', 'bonusType', 'youtube_categories', 'youtubeCategoryDays',
        'subscriberReach', 'balanceAction', 'bands'
      ])

      MessageBox.confirm(alertMsg, 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
          .then(() => {
            try {
              track.balance = track.balance * 10
              axios.api.post(`vc/label/campaign/update`, track)
                  .then(() => {
                    commit('setEditDialog', false)
                    this.dispatch('vcLabel/readLabels')
                  })
            } catch (err) {
              commit('setEditDialog', false)
            }
          })
          .catch(() => {
            Message({
              type: 'info',
              message: 'Deposit cancelled'
            })
          })
    },

    readTrackList({ state, commit }) {
      commit('setLoading', true)
      axios.admin
        .get(`vc/track/${state.active_label}`)
        .then(r => {
          commit('setTrackList', r.data.data)
          commit('setLoading', false)
        })
        .catch(() => {
          commit('setLoading', false)
        })
    },

    readCampaignPackages({ state, commit }) {
      commit('setLoading', true)
      axios.admin
          .get('campaign-packages')
          .then(r => {
            commit('setCampaignPackages', r.data.data)
            commit('setLoading', false)
          })
          .catch(() => {
            commit('setLoading', false)
          })
    }
  }
}
